module.exports = __webpack_public_path__ + "assets/img/LTC045.16d95a56.png";